import { Suspense } from 'react';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';
import { CertificateAuthoritiesPage } from './page/CertificateAuthoritiesPage.tsx';

/**
 * {@link CertificateAuthoritiesRoot} contains all of the routing config for the /certificate-authorities path
 */
export function CertificateAuthoritiesRoot() {
  return (
    <Titled title={() => page('Certificate Authorities')}>
      <Suspense fallback={<LoadingSpinner />}>
        <CertificateAuthoritiesPage />
      </Suspense>
    </Titled>
  );
}
